export default {
  meta: {
    title: 'Forum économique international des Amériques',
    description: `Le Forum économique international des Amériques (FEIA) encourage la connexion, la collaboration et l'innovation afin de relever les grands défis mondiaux.`
  },
  header: {
    message: 'Connecter les dirigeants du monde pour relever les grands',
    span: 'défis internationaux'
  },
  graphic: '/images/brand/graphic-fr.png',
  bullets: [
    {
      number: '23 200',
      label: 'Participants'
    },
    {
      number: '563',
      label: 'Conférenciers'
    },
    {
      number: '105',
      label: 'Pays\nreprésentés'
    },
    {
      number: '2 602',
      label: 'Rencontres\nbilatérales'
    }
  ],
  about: {
    title: 'Notre mission',
    content:
      "Le Forum économique international des Amériques (FEIA) a été créé en 1994 dans le but de promouvoir la coopération, la collaboration et l'innovation afin de relever les plus grands défis mondiaux. L'organisation s'appuie sur son vaste réseau pour organiser une série d'événements annuels dans le monde entier, au cours desquels des chefs d'État et de gouvernement, des membres du secteur privé et de la société civile, des dirigeants syndicaux et des académiques - tous experts dans leur domaine respectif - peuvent se réunir et discuter de leurs objectifs communs et des moyens de les atteindre."
  },
  testimonies: {
    title: 'Quelques extraits de nos conférences',
    slides: [
      {
        content:
          'La guerre, qui est absolument dramatique, a vraiment mis la notion de sécurité énergétique au premier plan.',
        name: 'Odile Renaud-Basso - Présidente, Banque européenne pour la reconstruction et le développement (BERD)',
        image: '/images/testimonials/OdileRenaud-Basso.jpg'
      },
      {
        content:
          "Je regarde les prochains 10-20 ans au Québec, je pense qu'il y a deux catalyses de création de valeur et de richesse au Québec : le premier c'est l'innovation, et le deuxième c'est comment on utilise nos ressources d'énergies renouvelables.",
        name: "Pierre Fitzgibbon - Ministre de l'Économie, de l'Innovation et de l'Énergie, Québec",
        image: '/images/testimonials/PierreFitzgibbon.jpg'
      },
      {
        content: `Nous sommes à une étape charnière de l'histoire en économie et en histoire géopolitique.`,
        name:
          "Mark Carney - Vice-président du conseil et chef de l'investissement en matière d'environnement chez Brookfield Asset Management, et envoyé spécial des Nations Unies pour le financement de l'action climatique",
        image: '/images/testimonials/MarkCarney.jpg'
      },
      {
        content:
          'La crise et le défi de la transition énergétique sont très clairs : il faudra que le gouvernement, les industries, et les consommateurs travaillent tous ensemble pour réussir ce changement, mais nous ne pouvons pas nous attendre les uns les autres.',
        name: 'Ivan Vella - Chef de la direction, Rio Tinto Aluminium',
        image: '/images/testimonials/IvanVella.jpg'
      },
      {
        content:
          "Lorsque nous pensons à l'engagement social, lorsque nous pensons aux médias sociaux, la capacité à comprendre les problèmes et à s'organiser collectivement autour d'eux s'accélère",
        name: 'Jean-Pierre Clamadieu - Président, ENGIE',
        image: '/images/testimonials/Jean-PierreClamadieu.jpg'
      }
    ]
  },
  boards: {
    upTitle: 'Événements annuel',
    title: 'Les comités',
    content:
      "Depuis sa fondation en 1994, le FEIA s'est entouré de dirigeants du monde des affaires, d'organisations internationales et d'autres leaders qui continuent d'appuyer sa mission au sein de différents comités et conseils. Consultez les différents comités pour en savoir plus sur ces personnes qui soutiennent notre mission."
  },
  partner: {
    title: 'Devenir',
    content:
      "Au cours des trois dernières décennies, le FEIA a bâti un réseau de leaders influents de classe internationale, issus des milieux gouvernementaux, économiques et universitaires. La capacité de l'organisation à favoriser la connexion et la collaboration fait du FEIA une plateforme unique pour ses partenaires.",
    content2:
      "Les partenaires et les sponsors jouent un rôle clé dans le développement et le succès continu du FEIA. En devenant un sponsor officiel, les partenaires peuvent rejoindre un réseau stratégique où les décideurs peuvent échanger et se connecter, ce qui permet des dialogues productifs et des relations de travail à long terme. Le FEIA s'engage à offrir une expérience enrichissante et inégalée à ses parties prenantes - un objectif qui s'est traduit par la création de nombreux partenariats d'année en année."
  },
  services: {
    title: 'Services-conseils du FEIA',
    content:
      'En plus de ses conférences phares, le Forum économique international des Amériques offre une variété de services pour les clients qui souhaitent étendre leur réseau stratégique ou produire leurs propres événements.',
    entries: [
      {
        title: 'Production d’événements',
        content:
          "<p>Le Forum a évolué et s'est développé au cours des trois dernières décennies pour rassembler chaque année plus de 23 000 participants et 560 intervenants dans le cadre de cinq conférences : la Conférence de Montréal, le Toronto Global Forum, le World Strategic Forum, la Conférence de Paris et l'IEFA LatAm Forum.</p><p>Tirant parti de cette expertise et de son vaste réseau, le FEIA organise et gère régulièrement des événements externes dans le monde entier. Le FEIA peut gérer, coordonner et fournir un ensemble d'événements de classe mondiale spécifiquement adaptés aux besoins du client. De la sélection des intervenants et du contenu jusqu’à la conception, la production et la stratégie de l’événement, le FEIA a pour objectif de fournir un service qui a un impact significatif pour ses clients.</p>"
      },
      {
        title: 'Réalisation de tables rondes',
        content:
          '<p>Le FEIA produit un programme de tables rondes aussi bien privées que virtuelles qui dure toute l’année et qui est indépendant de ses conférences annuelles.</p><p>Ces réunions se composent généralement d’environ 25 personnes et comprennent principalement des dirigeants d’entreprises et gouvernementaux du monde entier. Le format exact des tables rondes est adapté à chaque besoin du client.</p>'
      },
      {
        title: 'Conseils en réseautage exécutif',
        content:
          "<p>Le FEIA a passé les trois dernières décennies à construire un vaste réseau de leaders influents comprenant des dirigeants mondiaux, des cadres de haut niveau et des universitaires dans un large éventail de domaines. L'organisation est connue pour sa capacité à favoriser la connexion et la collaboration afin de relever les défis les plus pressants du monde, en adaptant spécifiquement ses audiences pour atteindre cet objectif. En fonction des objectifs du client, le FEIA peut faciliter une série de réunions privées individuelles et de présentations conçues pour créer un impact maximal.</p>"
      }
    ]
  },
  contact: {
    title: 'Nous contacter',
    content: `Pour communiquer avec nous, veuillez remplir le formulaire. Quelqu'un vous répondra dans les plus brefs délais.`,
    content2: ''
  },
  newsletter: 'Inscrivez-vous à notre infolettre'
}
